import AlertDialog from './AlertDialog';
import DeleteConfirmationDialog from './DeleteConfirmationDialog';

export default AlertDialog;
export { DeleteConfirmationDialog };
